import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  EQUIPMENT_STOCK_LIST,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT,
  EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT,
  EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT,
  EQUIPMENT_STOCK_ADD,
  EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_GET,
  EQUIPMENT_STOCK_UPDATE,
  EQUIPMENT_STOCK_UPLOAD_SET
} from '../../actions';
import {
  EquipmentStockListSuccess,
  EquipmentStockListError,
  EquipmentStockSearchAssessmentSuccess,
  EquipmentStockSearchAssessmentError,
  EquipmentStockSearchAssessmentProjectSuccess,
  EquipmentStockSearchAssessmentProjectError,
  EquipmentStockSearchSupervisionReportSuccess,
  EquipmentStockSearchSupervisionReportError,
  EquipmentStockAddSuccess,
  EquipmentStockAddError,
  EquipmentStockDetailSuccess,
  EquipmentStockDetailError,
  EquipmentStockGetSuccess,
  EquipmentStockGetError,
  EquipmentStockUpdateSuccess,
  EquipmentStockUpdateError,
  EquipmentStockUploadSetSuccess,
  EquipmentStockUploadSetError
} from '../../actions';
 
export function* watchEquipmentStockList() {
  yield takeEvery(EQUIPMENT_STOCK_LIST, onEquipmentStockList);
}

export function* watchEquipmentStockSearchAssessment() {
  yield takeEvery(EQUIPMENT_STOCK_SEARCH_ASSESSMENT, onEquipmentStockSearchAssessment);
}

export function* watchEquipmentStockSearchAssessmentProject() {
  yield takeEvery(EQUIPMENT_STOCK_SEARCH_ASSESSMENT_PROJECT, onEquipmentStockSearchAssessmentProject);
}

export function* watchEquipmentStockSearchSupervisionReport() {
  yield takeEvery(EQUIPMENT_STOCK_SEARCH_SUPERVISION_REPORT, onEquipmentStockSearchSupervisionReport);
}

export function* watchEquipmentStockAdd() {
  yield takeEvery(EQUIPMENT_STOCK_ADD, onEquipmentStockAdd);
}

export function* watchEquipmentStockDetail() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL, onEquipmentStockDetail);
}

export function* watchEquipmentStockGet() {
  yield takeEvery(EQUIPMENT_STOCK_GET, onEquipmentStockGet);
}

export function* watchEquipmentStockUpdate() {
  yield takeEvery(EQUIPMENT_STOCK_UPDATE, onEquipmentStockUpdate);
}

export function* watchEquipmentStockUpload() {
  yield takeEvery(EQUIPMENT_STOCK_UPLOAD_SET, onEquipmentStockUpload);
}

const onEquipmentStockListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentStockUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEquipmentStockSearchAssessmentAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockSearchAssessmentProjectAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment_project', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockSearchSupervisionReportAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/supervision_report', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEquipmentStockDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentStockGetAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock/get', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentStockUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/equipment_stock/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onEquipmentStockList(data) {
  try {
    const response = yield call(onEquipmentStockListAsync, data.payload);
    yield put(EquipmentStockListSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockListError(error));
  }
}

function* onEquipmentStockSearchAssessment(data) {
  try {
    const response = yield call(onEquipmentStockSearchAssessmentAsync, data.payload);
    yield put(EquipmentStockSearchAssessmentSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockSearchAssessmentError(error));
  }
}

function* onEquipmentStockSearchAssessmentProject(data) {
  try {
    const response = yield call(onEquipmentStockSearchAssessmentProjectAsync, data.payload);
    yield put(EquipmentStockSearchAssessmentProjectSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockSearchAssessmentProjectError(error));
  }
}

function* onEquipmentStockSearchSupervisionReport(data) {
  try {
    const response = yield call(onEquipmentStockSearchSupervisionReportAsync, data.payload);
    yield put(EquipmentStockSearchSupervisionReportSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockSearchSupervisionReportError(error));
  }
}

function* onEquipmentStockAdd(data) {
  try {
      const response = yield call(onEquipmentStockAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentStockAddSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEquipmentStockDetail(data) {
  try {
    const response = yield call(onEquipmentStockDetailAsync, data.payload);
    yield put(EquipmentStockDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentStockDetailError(error)); 
  }
}

function* onEquipmentStockGet(data) {
  try {
    const response = yield call(onEquipmentStockGetAsync, data.payload);
    yield put(EquipmentStockGetSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentStockGetError(error)); 
  }
}

function* onEquipmentStockUpdate(data) {
  try {
      const response = yield call(onEquipmentStockUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EquipmentStockUpdateSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockUpdateError(error));
  }
}

function* onEquipmentStockUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEquipmentStockUploadAsync, file);
    if(response.message ==='success'){
      yield put(EquipmentStockUploadSetSuccess(response));
    }
    else{
      yield put(EquipmentStockUploadSetError(response));
    }
  } catch (error) {
    yield put(EquipmentStockUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEquipmentStockList),
    fork(watchEquipmentStockSearchAssessment),
    fork(watchEquipmentStockSearchAssessmentProject),
    fork(watchEquipmentStockSearchSupervisionReport),
    fork(watchEquipmentStockAdd),
    fork(watchEquipmentStockDetail),
    fork(watchEquipmentStockGet),
    fork(watchEquipmentStockUpdate),
    fork(watchEquipmentStockUpload),
  ]);
} 